import { Overlay } from 'features/OverlayFunction/models/overlay';
import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import { Menu, MenuDetail } from '../../models/SubTitleMenu';

export interface GenreResponse {
  status: string;
  message: string;
  data: MenuDetail;
}

const config = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

const service = {
  getMenu(id: string): Promise<GenreResponse> {
    const url = `sub-title-menu/${id}`;
    return axiosClient.get(url);
  },
  updateMenu(body: Menu, id: string): Promise<GenreResponse> {
    const url = `sub-title-menu/${id}`;
    return axiosClient.put(url, body, config);
  },
  getOverlayGroups(): Promise<CommonResponse<Overlay[]>> {
    const url = '/overlays';
    return axiosClient.get(url);
  },
};

export default service;
